module.exports = __webpack_public_path__ + "static/media/MetuoPersonalUse-Thin.1b9901f6.otf";